import React from 'react';
import { Redirect } from 'react-router-dom';
import { RouteConfigComponentProps } from 'react-router-config';

const RouteRedirect: React.FC<RouteConfigComponentProps> = (props) => {
  const { route } = props;
  return <Redirect to={route && route.redirectUrl} />;
};

export default RouteRedirect;
